<template>
    <nav>
        <ul class="pagination justify-content-end">
            <li class="page-item" :class="{'disabled': isOnFirstPage}">
            <a class="page-link" @click.prevent="loadPage('prev')">
                <span>&laquo;</span>
            </a>
            </li>
            <template v-if="notEnoughPages">
            <li class="page-item" v-for="(n, index) in totalPage" :key="index" :class="{'active': isCurrentPage(n)}">
                <a class="page-link" @click.prevent="loadPage(n)" v-html="n"></a>
            </li>
            </template>
            <template v-else>
            <li class="page-item" v-for="(n, index) in windowSize" :key="index" :class="{'active': isCurrentPage(windowStart+n-1)}">
                <a class="page-link" @click.prevent="loadPage(windowStart+n-1)" v-html="windowStart+n-1"></a>
            </li>
            </template>
            <li class="page-item" :class="{'disabled': isOnLastPage}">
            <a class="page-link" @click.prevent="loadPage('next')">
                <span>&raquo;</span>
            </a>
            </li>
        </ul>
  </nav>
</template>

<script>
import VuetablePaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin'
export default {
  mixins: [VuetablePaginationMixin]
}
</script>